import { appChildren } from '@/app-routes';

/**
 * The AI assistant's "where things live" map, derived from the app's own route
 * table (`app-routes.jsx`) rather than hand-maintained. Any shop-scoped route
 * that carries a `handle.assistantPurpose` becomes an entry here, so adding a
 * page (with its `handle`) automatically teaches the assistant about it — no
 * second list to keep in sync.
 *
 * `path` is the unscoped (single-shop) route; in a chain the assistant links
 * are re-scoped to the active `:shopId` at render time via `useShopPath()`.
 */
const toPath = (route) => (route.index ? '/' : `/${String(route.path).replace(/\/?\*+$/, '')}`);

export const DASHBOARD_MAP = appChildren
	.filter((route) => route.handle?.assistantPurpose)
	.map((route) => ({ path: toPath(route), label: route.handle.label, purpose: route.handle.assistantPurpose }));

/**
 * Renders the map into the compact line-per-page form the assistant prompt
 * expects. Kept here so the wire format has one definition.
 */
export const formatDashboardMap = (map = DASHBOARD_MAP) => map.map((p) => `- ${p.label} (${p.path}): ${p.purpose}`).join('\n');
